import { useBlackCardContext } from 'root/src/client/web/base/Card/BlackCard/hooks/useBlackCardContext'
import { useDropEventCard } from 'root/src/client/web/list/listItemComponents/dropEvent/hooks/useDropEventCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'

export const DropEventFooter = withProjectCardStyle(({ classes }) => {
	const { isHovered } = useBlackCardContext()

	const {
		extraData: { maxDares, acceptedDares },
	} = useDropEventCard()

	if (isHovered && !maxDares && !acceptedDares.length) {
		return (
			<div className={classes.maxDares}>
				<FontAwesomeIcon icon={faLock} size="xl" />
				<p className={classes.maxDaresText}>
					Need more Viewers to Participate
				</p>
			</div>
		)
	}

	if (isHovered && !maxDares) {
		return (
			<div className={classes.maxDares}>
				<FontAwesomeIcon icon={faLock} size="xl" />
				<p className={classes.maxDaresText}>
					Based on your 30-day CCV and/or Follower count, you
					<br />
					have completed all available Dares
				</p>
			</div>
		)
	}

	return (
		<ButtonNew>
			Check Out Dares
		</ButtonNew>
	)
})
